import { render, staticRenderFns } from "./Audition.vue?vue&type=template&id=63225a37&scoped=true&"
import script from "./Audition.vue?vue&type=script&lang=js&"
export * from "./Audition.vue?vue&type=script&lang=js&"
import style0 from "./Audition.vue?vue&type=style&index=0&id=63225a37&prod&scoped=true&lang=scss&"
import style1 from "./Audition.vue?vue&type=style&index=1&id=63225a37&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63225a37",
  null
  
)

export default component.exports